import React from 'react';
import { MicroscopeIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { Reveal } from './Reveal';
export function FinalCTASection() {
  return <section className="bg-brand-deep px-4 py-24 text-center text-white" data-id="element-62" data-mp="3n4w8ryifi9ie">
      <Reveal className="mx-auto max-w-3xl" data-id="element-63" data-mp="3s2xsmlnoicux">
        <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-brand-lime/25 text-white" data-id="element-64" data-mp="welphkyr71w">
          <MicroscopeIcon className="h-7 w-7" aria-hidden="true" data-id="element-65" data-mp="2zejve84ezkkf" />
        </div>
        <h2 className="mt-5 text-4xl font-black md:text-5xl" data-id="element-66" data-mp="34c25w2y2y7uj">¿Listo para llevar la Biología a cada aula?</h2>
        <p className="mx-auto mt-5 max-w-xl leading-relaxed text-white/75" data-id="element-67" data-mp="39berkkd7t8vj">
          Deja de improvisar y empieza a enseñar con resultados reales.
        </p>
        <CTAButton className="mt-9 px-10 py-5 text-lg" data-id="element-68" data-mp="3e47y9ds8ura9">QUIERO EL PACK BIOLOGÍA LISTA</CTAButton>
        <p className="mt-4 text-xs font-semibold text-white/70" data-id="element-69" data-mp="2gl6j5k8he2u5">Acceso inmediato · Garantía de 7 días</p>
      </Reveal>
    </section>;
}